import { createFileRoute } from '@tanstack/react-router'
import { OnboardingFlow } from '@/features/onboarding/onboarding-flow'

export const Route = createFileRoute('/_auth/onboarding')({
  component: OnboardingPage,
})

function OnboardingPage() {
  return <OnboardingFlow />
}
